<script>
  import {
    ArrowUpIcon,
  } from "vue-feather-icons";
  import appConfig from "@/app.config";
  import axios from 'axios';
  import { EventBus } from "@/event-bus";
  import {
    read,
    utils,
    //writeFile
  } from 'xlsx';

  // 초기세팅
  function initialState() {
    return {
      token: "",
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      fields: [
        {key: 'status', label: '상태', thClass: 'text-center font-size-11', tdClass: 'text-center'},
        {key: 'memberType', label: '회원유형', thClass: 'text-center font-size-11', tdClass: 'text-center'},
        {key: 'name', label: '성명', thClass: 'col-1 text-center font-size-11', tdClass: 'text-center'},
        {key: 'phone', label: '연락처', thClass: 'text-center font-size-11', tdClass: 'text-center'},
        {key: 'email', label: '이메일', thClass: 'text-center font-size-11', tdClass: 'text-center'},
        {key: 'client_ip', label: '가입시 접속IP', thClass: 'text-center font-size-11', tdClass: 'text-center'},
        {key: 'insertTime', label: '가입일자', thClass: 'col-1 text-center font-size-11', tdClass: 'text-center'},
      ],
      giveMemberList: [],
      searchCondition: '정회원+후원회원',
      searchKeyword: '',
      // Pagination
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      totalPages: 0,
    };
  }
  
  export default {
    components: {
      ArrowUpIcon
    },
    data() {
      return initialState();
    },
    props: {
      selectedMenu: {
        type: String,
      },
    },
    computed: {
    },
    mounted() {
    },
    created() {
      this.first()
      EventBus.$on("give-member", (val)=> {
        if (val=='listRefresh') {
          this.readGiveMemberList();
        }
      });
    },
    methods: {
      first() {
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token
          // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
          if (this.login.level < 98) {
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
            this.$router.push('/');
          } else {
            this.readGiveMemberList()
          }
        } else {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        }
      },
      // 엑셀파일 업로드 모달 열기
      openExcelUploadModal() {
        this.$bvModal.show('excelUploadModal')
      },
      // 엑셀파일 업로드
      uploadExcelFile(event) {
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
          let data = e.target.result;
          data = new Uint8Array(data);
          let workbook = read(data, { type: "array" });
          let first_sheet_name = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[first_sheet_name];
          let json = utils.sheet_to_json(worksheet, { header: 1, defval: "" });
          if (json.length > 0) {
            this.postExcelFile(json);
          }
        };
        reader.readAsArrayBuffer(file); // ← 반드시 필요
      },
      postExcelFile(json) {
        // 필요한내용
        // 우리 DB에서는 성명(name), 회원구분(memberType), 휴대전화번호(phone), 이메일(email), 가입일 (insertTime)
        // 엑셀파일 데이터에서는 성명(2열), 회원구분(3열), 휴대전화번호(4열), 이메일(6열), 가입일 (31열)
        // insertTime은 2017-12-27 00:00:00 형식으로 넣어주자
        // status는 승인완료로 해두자
        // 첫번째행은 헤더이므로 제외하고 두번째행부터 _data 배열에 넣어주자
        let _data = [];
        for (let i = 1; i < json.length; i++) {
          let row = json[i];
          // row[31] 가입일자가 없으면 row[19] 값을 가입일자로 넣어주자
          if (row[31] == '' || row[31] == null) {
            row[31] = row[19];
          }
          let data = {
            name: row[2],
            memberType: row[3],
            phone: row[4],
            email: row[6],
            signRoute: row[7], // 가입경로 (기자 구분하려고)
            registerType: row[9], // 등록타입 (개인 or 기업/단체 구분하려고)
            insertTime: row[31] + ' 00:00:00',
            status: '승인완료',
          }
          _data.push(data);
        }
        this.loadingBar(true);
        axios({
          method: 'POST', url: appConfig.fastapi + '/auth/admin_upload_excel_file',
          headers: {
            'access-token': this.token
          },
          data: _data
        })
        .then((response) => {
          if (response.data.type == 'success') {
            this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: response.data.message })
            // 모달 닫자
            this.$bvModal.hide('excelUploadModal');
            // 현재창 조회 리플레쉬
            this.readGiveMemberList();
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: response.data.detail })
          }
        })
        .catch((error) => {
          this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: error.response.data.detail })
        })
        .finally(() => {
          this.loadingBar(false);
          this.readGiveMemberList();
        })
      },
      // 기다려주세요 loading 처리
      loadingBar(val) {
        this.$nextTick(() => {
          const preloader = document.getElementById("preloader");
          const status = document.getElementById("status");
          
          if (preloader && status) {
            if (val === true) {
              preloader.style.display = "block";
              status.style.display = "block";
            } else {
              preloader.style.display = "none";
              status.style.display = "none";
            }
          }
        });
      },
      // 정,후원 회원 목록 조회
      readGiveMemberList() {
        try {
          this.loadingBar(true)
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/admin_read_give_member_list',
            headers: {
              'access-token': this.token
            },
            data: {
              "mb_id": this.login.idx,
              "searchKeyword": this.searchKeyword,
              "searchCondition": this.searchCondition,
              "currentPage": this.currentPage,
              "perPage": this.perPage,
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              if (this.searchKeyword != '') {
                this.$notify({ type: 'success', duration: 3000, 'title': '성공', text: '검색된 회원 '+res.data.giveMemberList.length+'명 조회되었습니다.' })
              }
              this.giveMemberList = res.data.giveMemberList || [];
              this.totalRows = res.data.totalRows
              this.totalPages = res.data.totalPages
            } else {
              this.giveMemberList = [];
            }
          })
          .catch((error) => {
            console.log(error)
            this.giveMemberList = [];
            if (error.response) {
              this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
            }
          })
        } catch (error) {
          this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        } finally {
          this.loadingBar(false)
        }
      },
      detailGiveMember(row) {
        // 레벨 98 이상만 가능
        if (this.login.level >= 98) {
          // 모달 열자
          this.$store.commit('setModal_lgVal', row); // store.js 로 보내주자
          this.$store.commit('setModal_lgWorker', 'detailGiveMember'); // store.js 로 보내주자
          this.$root.$emit('bv::toggle::modal', 'modal_lg'); // 모달 오픈
        }
      },
      // 페이지 변경 핸들러 (watch에서 처리하므로 제거 가능하지만, 명시적으로 유지)
      onPageChange(button, page) {
        // button은 이벤트 객체, page는 페이지 번호
        this.currentPage = page
        this.readGiveMemberList()
      },
      selectSearchCondition() {
        // 검색어는 지워주자
        this.searchKeyword = ''
        // currentPage 초기화해주자
        this.currentPage = 1
        this.readGiveMemberList()
      },
      searchKeywordChange() {
        // 검색조건은 지워주자
        this.searchCondition = '전체명단'
        // currentPage 초기화해주자
        this.currentPage = 1
        this.readGiveMemberList()
      },
    },
  }
  </script>
  
  <template>
    <div v-show="giveMemberList !== null && giveMemberList !== undefined" class="rounded shadow">

      <!-- 엑셀파일 업로드 모달 -->
      <b-modal id="excelUploadModal" centered title="엑셀파일 업로드" hide-footer>  
        <div class="row">
          <div class="col-12 mb-2">
            <div class="text-center">
              <div class="font-size-13 text-muted">이름, 휴대전화번호, 이메일이 같은 사람은 기존 정보를 덮어쓰게 됩니다.</div>
              <div class="font-size-13 text-muted">가입경로상세에 있는 <b>"언론보도_기자"</b> 글자가 있다면 언론보도_기자로 인식합니다.</div>
              <div class="font-size-13 text-muted">등록구분에 있는 <b>"기업/단체"</b> 글자가 있다면 기업/단체으로 인식합니다.</div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="excelFile">파일 선택</label>
              <b-input-group>
                <b-form-file
                  id="excelFile"
                  accept=".xlsx,.xls"
                  @change="uploadExcelFile($event)"
                  placeholder="파일을 선택해주세요"
                  browse-text="찾아보기">
                </b-form-file>
              </b-input-group>
            </div>
          </div>
        </div>
      </b-modal>
      <!-- 엑셀파일 업로드 모달 종료 -->

      <div class="p-4 border-bottom">
        <h5 class="text-md-left text-center">정,후원 회원</h5>

        <!-- 상단 버튼 그룹 시작 -->
        <div class="card">
          <div class="card-body p-3">

            <div class="row">
              <!-- 기타 검색조건 버튼들 -->
              <div class="col-xl-9 col-md-12 col-sm-12 mb-2">
                <div class="row">
                  <div class="col-xl-6 col-md-12 col-sm-12 mb-2">
                    <label for="searchCondition" class="font-size-12 text-muted mb-0 d-block">조회조건 선택</label>
                    <select class="form-control form-control-sm" id="searchCondition" v-model="searchCondition" @change="selectSearchCondition">
                      <option value="전체명단">전체명단</option>
                      <option value="정회원+후원회원">정회원+후원회원</option>
                      <option value="정회원">정회원</option>
                      <option value="후원회원">후원회원</option>
                      <option value="비회원">비회원</option>
                      <option value="회원유형없음">회원유형없음</option>
                      <option value="언론보도_기자">언론보도_기자</option>
                      <option value="기업/단체">기업/단체</option>
                      <option value="문자수신거부">문자수신거부</option>
                      <option value="이메일수신거부">이메일수신거부</option>
                    </select>
                  </div>
                  <div class="col-xl-6 col-md-12 col-sm-12 mb-2">
                    <label for="searchMemberName" class="font-size-12 text-muted mb-0 d-block">검색어 입력</label>
                    <div class="input-group mb-0 p-0">
                      <input type="text" 
                      @keyup.enter="searchKeywordChange"
                      class="form-control form-control-sm" id="searchMemberName" v-model="searchKeyword" placeholder="ex) 성명 or 연락처 or 이메일 or 주소로 검색">
                      <div class="input-group-append">
                        <button class="btn btn-sm btn-info" @click="searchKeywordChange">검색</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-md-12 col-sm-12 mb-2">
                <label for="searchMemberName" class="font-size-12 text-muted mb-0 d-block">휴먼소프트웨어 회원엑셀 넣기</label>
                <div class="mb-0">
                  <button class="btn btn-block btn-sm btn-square btn-blue font-weight-bold" @click="openExcelUploadModal()">
                    <i class="mdi mdi-file-excel"></i> 엑셀파일 업로드
                  </button>
                </div>
              </div>
            </div> 
          </div>
        </div>
        <!-- 상단 버튼 그룹 종료 -->

        
        <div>
          <div class="row mt-2">
  
            <div class="col-12 pt-2">
              <div class="d-flex justify-content-between">
                <span class="font-size-12 text-muted">리스트: <b class="h5">{{ totalRows }}</b>명</span>
                <span class="text-center font-size-12">{{ currentPage }} / {{ totalPages }}페이지</span>
              </div>
              <div class="">
                <div class="">
                  <!-- Pagination -->
                  <div class="mt-3 mb-3 d-flex justify-content-center">
                    <ul class="pagination mb-0">
                      <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="giveMemberTable"
                        @page-click="onPageChange"
                        limit="6"
                      >
                        <template #first-text><span class="text-primary">처음</span></template>
                        <template #prev-text><span class="text-secondary">이전</span></template>
                        <template #next-text><span class="text-secondary">다음</span></template>
                        <template #last-text><span class="text-primary">마지막</span></template>
                        <template #page="{ page, active }">
                          <b v-if="active">{{ page }}</b>
                          <span v-else>{{ page }}</span>
                        </template>
                      </b-pagination>
                    </ul>
                  </div>
                  <!-- Pagination 종료 -->
                  <div class="table table-sm table-responsive font-size-14">
                    <b-table 
                      id="giveMemberTable" 
                      ref="giveMemberTable" 
                      :fields="fields" 
                      :items="giveMemberList" 
                      @row-clicked="detailGiveMember($event)"
                      :hover="true"
                      table-class="text-center cursor-pointer">
                      <!-- 신청인 -->
                      <template #cell(name)="row">
                        <div class="badge text-dark bg-white font-size-11">
                          {{ row.item.name }}
                        </div>
                      </template>
                      <!-- 회원유형 -->
                      <template #cell(memberType)="row">
                        <div class="badge text-secondary bg-white font-size-10">
                          {{ row.item.memberType }}
                        </div>
                      </template>
                      <!-- 연락처 -->
                      <template #cell(phone)="row">
                        <div class="badge text-secondary bg-white font-size-10">
                          {{ row.item.phone }}
                        </div>
                      </template>
                      <!-- 이메일 -->
                      <template #cell(email)="row">
                        <div class="badge text-secondary bg-white font-size-10">
                          {{ row.item.email }}
                        </div>
                      </template>
                      <!-- 가입시 접속IP -->
                      <template #cell(client_ip)="row">
                        <div class="badge text-secondary bg-white font-size-10">
                          {{ row.item.client_ip }}
                        </div>
                      </template>
                      <!-- 가입일자 -->
                      <template #cell(insertTime)="row">
                        <div class="badge text-secondary bg-white font-size-10">
                          {{ row.item.insertTime }}
                        </div>
                      </template>
                      <!-- 상태 -->
                      <template #cell(status)="row">
                        <div class="badge text-secondary border border-secondary bg-white font-size-10">
                          <span v-if="row.item.status == '승인요청'" class="text-warning">승인요청</span>
                          <span v-if="row.item.status == '승인보류'" class="text-danger">승인보류</span>
                          <span v-if="row.item.status == '승인완료'" class="text-primary">승인완료</span>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!giveMemberList" class="text-center py-4">
        <div class="spinner-border text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </template>